
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

import vSelect from "vue-select"

import api from "@/services/api"

import { CellType, Dashboard, Team } from "@/types"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class DashboardEditbar extends Vue {
	@Prop()
	value!: Dashboard;

	@Prop()
	cellTypes!: CellType[];

	@Prop()
	addingCellType!: number | null;

	@State teams!: Team[];

	get addCellType (): CellType | null {
		return this.addingCellType ? this.cellTypes.find(cellType => cellType.cellTypeId === this.addingCellType)! : null
	}

	privacyTypes = [
		{ key: 0, label: "Public" },
		{ key: 1, label: "Teams" },
		{ key: 2, label: "Private" }
	];

	@Emit("addCell")
	addCell (cellType: CellType) {
		return cellType
	}

	@Emit("fineGridChanged")
	toggleFineGrid () {
		return !this.value.fineGridEnabled
	}

	@Emit("input")
	titleChanged (title: string) {
		return { ...this.value, title }
	}

	@Emit("input")
	privacyChanged (privacy: number) {
		return { ...this.value, privacy }
	}

	@Emit("input")
	limitedToTeamsChanged (limitedToTeams: string[]) {
		return { ...this.value, limitedToTeams }
	}
}

